import {
    ComposerAttributeNode,
    ComposerAttributeOptionNode,
    ComposerOptionActionNode
} from '../../../configurator-components/composer-editors/attributes/composerAttributesModels';
import { setActionSceneElementType } from './composerHelpers';
import { validateComposerAttributes, validateComposerOptions } from './composerAttributeValidation';

export const LazyValidateAttributes = async (attributeList: ComposerAttributeNode[]): Promise<ComposerAttributeNode[]> => {
    const validatedAttributes = validateComposerAttributes(attributeList);
    await Promise.all(validatedAttributes.flatMap((attribute) => attribute.options.map((option) => LazyValidateActions(option.actions))));
    return validatedAttributes;
};

export const LazyValidateOptions = async (
    attribute: ComposerAttributeNode,
    optionList: ComposerAttributeOptionNode[]
): Promise<ComposerAttributeOptionNode[]> => {
    const validatedOptions = validateComposerOptions(attribute, optionList);
    await Promise.all(validatedOptions.map((option) => LazyValidateActions(option.actions)));
    return validatedOptions;
};

export const LazyValidateActions = async (actionList: ComposerOptionActionNode[]): Promise<ComposerOptionActionNode[]> => {
    return new Promise<ComposerOptionActionNode[]>((resolve) => {
        actionList.forEach((action) => {
            // fix wrong scene action types
            setActionSceneElementType(action);
        });
        resolve(actionList);
    });
};
